import * as api from '@/api'

const menu = {
  namespaced: true,
  state: {
    menu: [],
    scrollPositions: [],
    isFetching: false,
    activeCategoryId: null,
    shouldUpdate: false,
    menuDisplay: 2, // 初回の場合は2列,
  },
  getters: {
    getHasMenu: (state) => !!state.menu.length,
    getMenu: (state) => state.menu,
    getActiveMenu: (state, getters) => {
      const activeCategoryIndex = getters.getActiveCategoryIndex
      return state.menu[activeCategoryIndex]
    },
    getScrollPositionById: (state) => (categoryId) =>
      state.scrollPositions.find((position) => position.categoryId === categoryId).amount,
    getIsFetching: (state) => state.isFetching,
    getCategories: (state) =>
      state.menu.map((category) => ({
        categoryId: category.categoryId,
        name: category.name,
      })),
    getActiveCategoryId: (state) => {
      return state.activeCategoryId
    },
    getActiveCategoryIndex: (_state_, getters) => {
      const categories = getters.getCategories
      const activeCategoryId = getters.getActiveCategoryId
      if (activeCategoryId === null) return 0
      return categories.findIndex((category) => category.categoryId === activeCategoryId)
    },
    getShouldUpdate: (state) => {
      return state.shouldUpdate
    },
    getMenuDisplay: (state) => {
      return state.menuDisplay
    },
    getItemByItemCode: (state) => (itemCode) =>
      state.menu.reduce((acc, menu) => {
        return acc || menu.itemList.find((menuItem) => menuItem.itemCode === itemCode)
      }, null),
    getItemExists: (state) => (item) =>
      state.menu.reduce(
        (acc, menu) =>
          acc || !!menu.itemList.find((menuItem) => menuItem.itemCode === item.itemCode),
        false
      ),
  },
  actions: {
    async fetchMenu({ commit, dispatch, getters, rootGetters }, force = false) {
      if (!force && getters.getIsFetching) return
      const seatNo = rootGetters['seat/getSeatNo']
      const shopId = rootGetters['seat/getShopId']
      // 座席番号が未定義の場合は,事前注文用の席番号0を指定
      const validSeatNo = seatNo || 0
      commit('fetchMenuStart')
      try {
        const res = await api.fetchMenu(shopId, validSeatNo)
        if (!getters.getHasMenu) {
          commit('setActiveCategoryId', res.data[0].categoryId)
        }
        await dispatch('setMenu', res.data)
      } catch (error) {
        commit('fetchMenuFailed')
      }
    },
    async setMenu({ commit }, payload) {
      return new Promise((resolve, reject) => {
        try {
          commit('fetchMenuDone', payload)
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    setScrollPosition: ({ commit }, payload) => {
      commit('setScrollPosition', payload)
    },
    setActiveCategoryId: ({ commit }, payload) => {
      commit('setActiveCategoryId', payload)
    },
    setShouldUpdate({ commit }, payload) {
      commit('setShouldUpdate', payload)
    },
    setMenuDisplay: ({ commit }, payload) => {
      commit('setMenuDisplay', payload)
    },
  },
  mutations: {
    fetchMenuStart(state) {
      state.isFetching = true
    },
    fetchMenuDone(state, payload) {
      state.menu = payload
      state.scrollPositions = state.menu.map(({ categoryId }) => {
        const index = state.scrollPositions.findIndex(
          (scrollPosition) => scrollPosition.categoryId === categoryId
        )
        const amount = state.scrollPositions[index] ? state.scrollPositions[index].amount : 0
        return {
          categoryId,
          amount,
        }
      })
      state.isFetching = false
    },
    fetchMenuFailed(state) {
      state.isFetching = false
    },
    setActiveCategoryId(state, activeCategoryId) {
      state.activeCategoryId = activeCategoryId
    },
    setShouldUpdate(state, payload) {
      state.shouldUpdate = payload
    },
    setMenuDisplay(state, menuDisplay) {
      state.menuDisplay = menuDisplay
    },
    setScrollPosition(state, { id, amount }) {
      const index = state.scrollPositions.findIndex((position) => position.categoryId === id)
      if (state.scrollPositions[index]) state.scrollPositions[index].amount = amount
    },
  },
}

export default menu
